import script from "./TermsConditionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsConditionsPage.vue?vue&type=script&setup=true&lang=js"

import "./TermsConditionsPage.vue?vue&type=style&index=0&id=477e36e2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477e36e2"]])

export default __exports__